import AddIcon from "@mui/icons-material/Add"
import AssignmentIcon from "@mui/icons-material/Assignment"
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary"
import Edit from "@mui/icons-material/Edit"
import StorefrontIcon from "@mui/icons-material/Storefront"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import ShowChartIcon from "@mui/icons-material/ShowChart"
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"

const routes = [
  { text: "Create Listing", to: "/", icon: AddIcon },
  {
    text: "My Listings",
    to: "/my-listings",
    icon: AssignmentIcon
  },
  {
    text: "Gallery",
    to: "/gallery",
    icon: PhotoLibraryIcon
  },
  {
    text: "Bulk Edit",
    to: "/bulk-edit",
    icon: Edit
  },
  {
    text: "Meesho Calculator",
    to: "/meesho-calculator",
    icon: StorefrontIcon,
    children: [
      { text: "Profit", to: "/meesho-calculator", icon: AccountBalanceWalletIcon },
      { text: "Chart", to: "/meesho-calculator/chart", icon: ShowChartIcon }
    ]
  },
  {
    text: "Amazon Calculator",
    to: "/amazon-calculator",
    icon: ShoppingCartIcon,
    children: [
      { text: "Profit", to: "/amazon-calculator", icon: AccountBalanceWalletIcon },
      { text: "Chart", to: "/amazon-calculator/chart", icon: ShowChartIcon }
    ]
  }
  // { text: "Preview", to: "/preview", icon: PhoneIphoneIcon }
]

export { routes }
